import { PublicKey } from "@solana/web3.js";

export const STSOL_MINT = new PublicKey("7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj");

export const SOLIDO_PROGRAM = new PublicKey("CrX7kMhLC3cSsXJdT7JDgqrRVWGnUpX3gfEfxxU2NVLi");
